/** @jsxImportSource @emotion/react */
import { memo, useState } from "react";

// CSS読み込み
import {
  optionContainer,
  optionLabel,
  optionLabelRequired,
  optionLabelAny,
  modalWrap,
  modalWrap_hidden,
  modalContents,
  closeImg,
} from "assets/css/stylesCss";

import {
  hintText,
} from "assets/css/shchMtmr";

import LabelWithHint from "components/ui/label/LabelWithHint";
import ModalHowToShootKyutoki from "screens/modal/ModalHowToShootKyutoki";
import ModalHowToShootGasStove from "screens/modal/ModalHowToShootGasStove";

const closeSmall = require("assets/img/close/ico-close.png");
const closeMedium = require("assets/img/close/ico-close@2x.png");
const closeLarge = require("assets/img/close/ico-close@3x.png");

/**
 * 任意・ヒント付きラベルコンポーネント
 * TODO：写真アップロードに特化しすぎてて、使い物にならないから7月に修正する？
 * @param {String} title タイトル
 * @param {Boolean} required true : 必須
 *                           false: 任意
 * @param {String} children 子要素
 * @param {Boolean} isShow ヒントをタイトル横に表示しないか※isShowは画像添付されているかを持つ
 *                         true : ヒントを表示しない
 *                         false: ヒントを表示する
 */
const LabelTitleWithHintImg = memo(({ title, required, children, isShow }) => {

  // モーダルを開いているかどうか
  const [isOpenModal, setIsOpenModal] = useState(false);

  return (
    <>
      <label css={optionContainer}>
        <div>
          <span css={optionLabel}>{title}</span>
          {!isShow && (
            <div css={hintText}>
              {/** ヒント（給湯器の撮り方） */}
              <LabelWithHint title={"給湯器の撮り方"} isShow={!isShow}>
                <ModalHowToShootKyutoki />
              </LabelWithHint>

              {/** ヒント（ガスコンロの撮り方） */}
              <LabelWithHint title={"ガスコンロの撮り方"} isShow={!isShow}>
                <ModalHowToShootGasStove />
              </LabelWithHint>
            </div>
          )}
        </div>
        <span>
          {/** 必須・任意ラベル */}
          {required
            ? <span css={optionLabelRequired}>必須</span>
            : <span css={optionLabelAny}>任意</span>
          }
        </span>
      </label>
      {/* モーダル */}
      <div
        css={isOpenModal ? modalWrap : modalWrap_hidden}
        onClick={() => setIsOpenModal(false)}
      >
        {/* 親要素のonClick処理を中断 */}
        <div css={modalContents} onClick={(e) => e.stopPropagation()}>
          {children}
          <img
            css={closeImg}
            onClick={() => setIsOpenModal(false)}
            src={closeSmall}
            srcSet={`${closeSmall} 1x, ${closeMedium} 2x, ${closeLarge} 3x`}
            alt="閉じるアイコン"
          />
        </div>
      </div>
    </>
  );
});

export default LabelTitleWithHintImg;